import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import NodeTypeIcon from '../NodeTypeIcon';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import './style.css';
import { WALKTHROUGH_START } from '../../redux/actions/app';

const coords = {
    desktop: {
        x: ( window.innerWidth / 2 ) - 300,
        y: ( window.innerHeight / 2 ) - 125
    },
    mobile: {
        x: ( window.innerWidth / 2 ) - 150,
        y: ( window.innerHeight / 2 )
    }
}

const WelcomeNode = () => {

    const dispatch = useDispatch(),
    labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    theme = useTheme(),
    isMobile = useMediaQuery( theme.breakpoints.down('md') );

    const startWalkthrough = () => {
        dispatch({ type: WALKTHROUGH_START });
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <g className="coe__welcome" transform={ `translate(${ coords[ isMobile ? 'mobile' : 'desktop' ].x } ${ coords[ isMobile ? 'mobile' : 'desktop' ].y } )` }>
            <rect 
                className="coe__welcome__container" 
                rx="5"
                x="0" 
                y="0" />
            <NodeTypeIcon type="chain" x='260' y='-50' />
            <text className="coe__welcome__title" x="300" y="43">
                { labels.welcome }
            </text>
            <text className="coe__welcome__title" x="300" y="43">
                { labels.welcome }
            </text>
            <text className="coe__welcome__body" y="60">
                {
                    labels.instructions.split( '\n' ).map(
                        ( text, index ) => (
                            <tspan x="300" dy="1.5em" key={ 'welcome-' + index } dangerouslySetInnerHTML={{ __html: text }} />
                        )
                    )
                }
                <tspan x="300" dy="1.5em" onClick={ startWalkthrough } className="coe__welcome__help" style={{ fill: theme.palette.primary.dark }}>
                    { labels.needHelp }
                </tspan>
            </text>
        </g>
    )

}

export default WelcomeNode